/* eslint no-undef: 0 */
import React, { Component } from 'react';
import { Glyphicon } from 'react-bootstrap';
import moment from 'moment';
import _ from 'underscore';
import { titleize } from 'underscore.string';
import { withTranslation, useTranslation } from 'react-i18next';
import ShipmentWebAPIUtils from 'utils/ShipmentWebAPIUtils';
import classnames from 'classnames';
import JobStatus from 'components/modules/shipments/tracking/JobStatus';
import CargomaticMap from 'components/v2/map';
import CargomaticCard from 'components/v2/card';
import CargomaticInput from 'components/v2/input';
import SessionStore from 'stores/SessionStore';
import qs from 'qs';
import Spinner from 'components/ui/Spinner';
import TrackingHeader from 'components/ui/tracking-header';
import { sluggify } from 'utils/localization/utils';
import ShipmentHolds from '../shipments/ShipmentHolds';
import ShipmentDates from '../shipments/ShipmentDates';
const getNextStopMessage = (nextStop, t) => {
    try {
        const isLoggedIn = SessionStore.isLoggedIn();
        const address = isLoggedIn
            ? nextStop === null || nextStop === void 0 ? void 0 : nextStop.location[0].address
            : `${nextStop.location[0].city}, ${nextStop.location[0].state}`;
        if (nextStop.action === 'pickup') {
            const pickUpAddressSlug = nextStop.empty
                ? 'PICKING_UP_EMPTY_ADDRESS'
                : 'PICKING_UP_ADDRESS';
            return t(pickUpAddressSlug, {
                address,
            });
        }
        if (!nextStop.empty) {
            return t('DELIVERING_ADDRESS', {
                address,
            });
        }
        return t('RETURN_EMPTY_ADDRESS', {
            address,
        });
    }
    catch (e) {
        console.log(e);
    }
};
const ProTip = (props) => {
    const { message } = props;
    const { t } = useTranslation();
    return (React.createElement("div", { className: "pt-4" },
        React.createElement("div", { className: "flex items-center w-full p-2 leading-none text-white bg-green lg:rounded-full lg:inline-flex" },
            React.createElement("span", { className: "flex px-2 py-1 pr-1 text-sm font-bold uppercase rounded-full bg-green" }, t('PRO_TIP')),
            React.createElement(Glyphicon, { className: "pr-2 text-xsm", glyph: "pencil" }),
            React.createElement("span", null, message))));
};
const Preview = (props) => {
    const { nextStop, shipment, identifier, isLoggedIn, disableScroll, showBookAppointment, history, } = props;
    const { t } = useTranslation();
    if (!shipment)
        return null;
    const jobStatusStyles = disableScroll
        ? {}
        : { maxHeight: 500, minHeight: 450, overflowY: 'scroll' };
    const handleBookAppointment = () => {
        let masterBol = '';
        let container = '';
        shipment.reference_numbers.forEach((reference) => {
            const { name, value } = reference;
            if (name === 'master_bol') {
                masterBol = value;
            }
            if (name === 'equipment_id') {
                container = value;
            }
        });
        history.push(`/appointments/new?masterbol=${masterBol}&container=${container}`);
    };
    return (React.createElement(CargomaticCard, null,
        React.createElement("div", { className: "flex justify-between pb-4 border-b border-solid border-grey-light" },
            React.createElement("div", null,
                React.createElement("h2", { className: "p-0 m-0 text-grey-darker" }, identifier)),
            React.createElement("div", { className: "pt-2" },
                React.createElement("span", { className: "px-2 py-1 text-white truncate rounded bg-green" }, titleize(t(sluggify(shipment.status)))))),
        shipment && React.createElement(ShipmentHolds, { shipment: shipment }),
        shipment && React.createElement(ShipmentDates, { shipment: shipment }),
        showBookAppointment && (React.createElement("button", { onClick: () => handleBookAppointment(), className: "button button-green w-full flex justify-center items-center gap-x-2 my-2" },
            ' ',
            React.createElement(Glyphicon, { glyph: "list" }),
            t('BOOKING_APPOINTMENT'))),
        nextStop && (React.createElement("div", { className: "pb-6 border-b border-solid border-grey-light" },
            React.createElement("h4", { className: "text-green" }, t('NEXT_STOP')),
            React.createElement("span", null, getNextStopMessage(nextStop, t)),
            nextStop.window_start && nextStop.window_end && (React.createElement("div", null,
                React.createElement("span", { className: "italic" }, moment(nextStop.window_start).format('L, LT')),
                ' ',
                "-",
                React.createElement("span", { className: "px-1 italic" }, moment(nextStop.window_end).format('L, LT')))))),
        React.createElement("div", { style: jobStatusStyles },
            React.createElement(JobStatus, { job: shipment, hideReason: !isLoggedIn, hideAttachment: !isLoggedIn })),
        React.createElement("div", { className: "border-t border-solid border-grey-light" },
            React.createElement(ProTip, { message: t('TRACKING_DATA_UPDATE_TIP') }))));
};
const SearchByReference = (props) => {
    const { t } = useTranslation();
    const { value, error, disabled, history } = props;
    return (React.createElement(CargomaticCard, null,
        React.createElement("h4", { className: "text-grey-darker" }, t('REALTIME_TRACKING_INFO')),
        React.createElement("div", { className: "flex" },
            React.createElement("div", { className: "w-5/6" },
                React.createElement(CargomaticInput, { hideLabel: true, error: error, placeholder: t('SEARCH_BY_REF'), info: t('PROVIDE_KNOWN_TRACING'), onChange: (reference) => props.onChange(reference), value: value })),
            React.createElement("div", { className: "w-1/6 p-0 px-2" },
                React.createElement("button", { className: "button button-green", onClick: () => props.onQuery(), disabled: disabled },
                    React.createElement("div", { className: "" },
                        props.loading && React.createElement(Spinner, { showMessage: false }),
                        !props.loading && React.createElement("span", null, t('SEARCH'))))))));
};
const ShipmentList = (props) => {
    const { shipments, identifier, selected } = props;
    const { t } = useTranslation();
    const getRowClassName = (index, id) => {
        return classnames({
            'bg-white': index % 2 !== 0,
            'bg-grey-lightest': index % 2 === 0,
            flex: 1,
            'py-2': 1,
            'px-2': 1,
            border: selected === id,
            'border-green': selected === id,
            'border-solid': selected === id,
            'cursor-pointer': 1,
        });
    };
    return (React.createElement(CargomaticCard, null,
        React.createElement("span", null, t('MULTI_SHIPMENT_REF_MATCH_TIP')),
        React.createElement("div", { className: "flex py-2 border-b border-solid border-grey-light" },
            React.createElement("div", { className: "w-1/3" },
                React.createElement("span", { className: "form-label" }, t('REFERENCE'))),
            React.createElement("div", { className: "w-1/3" },
                React.createElement("span", { className: "form-label" }, t('STATUS'))),
            React.createElement("div", { className: "w-1/3" },
                React.createElement("span", { className: "form-label" }, t('CREATED')))),
        shipments.map((shipment, i) => {
            return (React.createElement("div", { className: getRowClassName(i, shipment._id), key: i, onClick: () => props.onClick(shipment) },
                React.createElement("div", { className: "w-1/3" },
                    React.createElement("button", { className: "font-bold text-blue-dark", onClick: () => props.onClick(shipment) }, identifier)),
                React.createElement("div", { className: "w-1/3" },
                    React.createElement("span", { className: "px-2 py-1 text-white break-words truncate rounded bg-green" }, titleize(t(sluggify(shipment.status))))),
                React.createElement("div", { className: "w-1/3" },
                    React.createElement("span", { className: "" }, moment(shipment.created_at).fromNow()))));
        })));
};
const MAX_MAP_HEIGHT = '100vh';
const MIN_MAP_HEIGHT = 350;
const MD = 768;
class PublicShipmentTracking extends Component {
    constructor(props) {
        super(props);
        this.query = async () => {
            const { reference } = this.state;
            const { t } = this.props;
            this.setState({ loading: true }, async () => {
                this.setQueryParams(reference);
                const shipments = await ShipmentWebAPIUtils.getTrackingShipments(reference);
                const selected = shipments.length > 0 ? _.first(shipments) : null;
                const error = !selected ? new Error(t('NO_SHIPMENT_FOUND_FOR_REF')) : {};
                this.setState({
                    loading: false,
                    shipments,
                    identifier: reference,
                    selected,
                    error,
                });
            });
        };
        this.handleReferenceChange = (reference) => {
            const { t } = this.props;
            if (reference)
                return this.setState({ reference: reference.toUpperCase().trim() }); // Query uppercase optimized
            this.setState({
                reference: '',
                error: new Error(t('PROVIDE_SEARCH_VALUE')),
            });
        };
        this.onShipmentSelect = (selected) => {
            this.setState({ selected });
        };
        const { search } = props.location;
        const parsed = search ? qs.parse(search.replace('?', '')) : null;
        this.state = {
            error: null,
            shipments: [],
            selected: null,
            identifier: '',
            reference: search ? parsed.id : '',
            loading: false,
            // center: { lat: 90, lng: 118 },
            mapHeight: window.innerWidth >= MD ? MAX_MAP_HEIGHT : MIN_MAP_HEIGHT,
        };
    }
    _googleMapRef(m) {
        if (m) {
            this._map = m;
        }
    }
    componentDidMount() {
        const { reference } = this.state;
        if (reference !== '')
            this.query(); // If query param exists
        window.addEventListener('resize', () => {
            if (this._map) {
                if (window.innerWidth < MD && this.state.mapHeight !== MIN_MAP_HEIGHT) {
                    this.setState({ mapHeight: MIN_MAP_HEIGHT }, () => {
                        google.maps.event.trigger(this._map.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, 'resize');
                    });
                }
                else if (window.innerWidth > MD &&
                    this.state.mapHeight !== MAX_MAP_HEIGHT) {
                    this.setState({ mapHeight: MAX_MAP_HEIGHT }, () => {
                        google.maps.event.trigger(this._map.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, 'resize');
                    });
                }
            }
        });
    }
    setQueryParams(reference) {
        this.props.history.push({
            path: '/tracking',
            search: `id=${reference}`,
        });
    }
    nextStop(stops) {
        const sorted = _.sortBy(stops, 'sequence');
        return _.find(sorted, (stop) => {
            return !stop.complete;
        });
    }
    markers(stops) {
        const filtered = stops.filter((s) => {
            return !s.empty;
        });
        return filtered.map((s) => {
            return {
                coords: {
                    lat: s.location[0].lat,
                    lng: s.location[0].lng,
                },
                icon: {
                    url: `/img/stop-${s.sequence}.png`,
                },
            };
        });
    }
    getDriverMarker(driver, current) {
        var _a;
        if (((_a = driver === null || driver === void 0 ? void 0 : driver.coords) === null || _a === void 0 ? void 0 : _a.length) > 0 && current) {
            return {
                coords: {
                    lat: driver.coords[1],
                    lng: driver.coords[0],
                },
                icon: {
                    url: '/img/working-truck.png',
                },
            };
        }
        return null;
    }
    isDisabled() {
        const { error, reference } = this.state;
        return !_.isEmpty(error) || !reference;
    }
    render() {
        const isLoggedIn = SessionStore.isLoggedIn();
        const isConsignee = SessionStore.getUserType() === 'Consignee';
        const isCarrier = SessionStore.getUserType() === 'Carrier';
        const { mapHeight, selected, shipments, 
        // loading,
        identifier, reference, error, } = this.state;
        let shipment;
        if (selected) {
            shipment = selected;
        }
        else {
            shipment = _.first(shipments);
        }
        const nextStop = shipment ? this.nextStop(shipment.stops) : {};
        const markers = shipment ? this.markers(shipment.stops) : [];
        const driverMarker = this.getDriverMarker(shipment === null || shipment === void 0 ? void 0 : shipment.driver, shipment === null || shipment === void 0 ? void 0 : shipment.current);
        if (driverMarker) {
            markers.push(driverMarker);
        }
        const containerClassNames = classnames({
            absolute: !isLoggedIn,
            relative: isLoggedIn,
            'top-0': 1,
            'left-0': 1,
            'w-full': 1,
        });
        return (React.createElement("div", { className: containerClassNames },
            React.createElement(TrackingHeader, { isLoggedIn: isLoggedIn }),
            React.createElement("div", { className: "flex" },
                React.createElement("div", { className: "w-full" },
                    React.createElement("div", { className: "z-10 md:absolute md:right-0 md:mt-8 md:mr-8 md:w-1/3 sm:w-full sm:relative" },
                        React.createElement(SearchByReference, { disabled: this.isDisabled(), error: error, onQuery: this.query, value: reference, loading: this.state.loading, onChange: this.handleReferenceChange, history: this.props.history }),
                        shipments.length > 1 && (React.createElement("div", { className: "py-2" },
                            React.createElement(ShipmentList, { selected: shipment._id, identifier: identifier, shipments: shipments, onClick: this.onShipmentSelect })))),
                    React.createElement("div", { className: "w-full md:absolute md:left-0" },
                        React.createElement("div", { className: "h-full sm:h-200px", style: { height: this.state.mapHeight } },
                            React.createElement(CargomaticMap, { getMapComponent: (m) => this._googleMapRef(m), defaultZoom: 10, height: mapHeight, markers: markers }))),
                    React.createElement("div", { className: "md:absolute md:left-0 md:ml-8 md:mt-8 md:w-1/3 sm:w-full sm:relative" }, shipment && (React.createElement(Preview, { disableScroll: mapHeight === MIN_MAP_HEIGHT, shipment: shipment, nextStop: nextStop, identifier: identifier, isLoggedIn: isLoggedIn, showBookAppointment: isConsignee || isCarrier, history: this.props.history })))))));
    }
}
export default withTranslation()(PublicShipmentTracking);
